// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import PaginationComponent from "../../Components/PaginationComponent";
// import toast from "react-hot-toast";
// import AddMedicineModal from "../../Components/AddMedicineModal";
// import productService from "../../Services/productService";
// import WarningAmberIcon from "@mui/icons-material/WarningAmber";
// import Stack from "@mui/material/Stack";
// import Pagination from "@mui/material/Pagination";

// const Products = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isOpen, setIsOpen] = useState();

//   useEffect(() => {
//     const getMedicines = async () => {
//       try {
//         setLoading(true);
//         const response = await productService.fetchMedicines();
//         console.log(response);
//         setRecords(response.products);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching Patients");
//       }
//     };
//     getMedicines();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       records?.filter((item) =>
//         item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, records]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleAddProduct = (data) => {
//     productService.create(data).then((res) => {});
//   };

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">
//           Medicines
//         </h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row justify-between items-center px-[3%]">
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Medicines Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 border-b-2 border-gray-200 focus:border-primary focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-400 ml-2" />
//           </div>
//           <div className="flex justify-end">
//             <button
//               onClick={() => setIsOpen(true)}
//               type="button"
//               className="bg-white text-primary shadow-[2px_2px_6px_rgba(0,0,0,0.2)] px-8 py-3 rounded-lg font-[600] text-[14px]"
//             >
//               + Add Medicine
//             </button>
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-full border-collapse rounded-lg overflow-hidden shadow-xl shadow-gray-300">
//             <thead>
//               <tr className="bg-primary text-white text-xs capitalize leading-normal text-left">
//                 <th className="p-4 w-[10%]">Sr No.</th>
//                 <th className="p-4 w-[20%]">Medicine Name</th>
//                 <th className="p-4 w-[15%]">Item Code</th>
//                 <th className="p-4 w-[15%]">Qty</th>
//                 <th className="p-4 w-[15%]">Sale Price</th>
//                 <th className="p-4 w-[15%]">Discount Price</th>
//               </tr>
//             </thead>
// <tbody>
//   {paginatedData?.map((patient, index) => (
//     <tr key={patient?.id} className="text-xs border-t border-gray-200">
//       <td className="p-4 w-[10%] font-bold text-primary">{patient?.stock_id}</td>
//       <td className="p-4 w-[20%] font-bold">{patient?.medicine_name}</td>
//       <td className="p-4 w-[15%]">{patient?.item_code}</td>
//       <td className="p-4 w-[15%] flex items-center gap-2">
//         {patient?.quantity}
//         {patient?.quantity < 4 && (
//           <WarningAmberIcon className="text-red-500" titleAccess="Low Stock" />
//         )}
//       </td>
//       <td className="p-4 w-[15%] font-semibold">{patient.sale_price}</td>
//       <td className="p-4 w-[15%] font-semibold">
//         {parseFloat(patient.sale_price - patient.discount_price).toFixed(2)}
//       </td>
//     </tr>
//   ))}
// </tbody>

//           </table>
//         </div>

//         <div className="flex justify-center my-4">
//           <Stack spacing={2}>
//             <Pagination
//               count={Math.ceil(filteredData.length / itemsPerPage)}
//               page={currentPage}
//               onChange={handlePageChange}
//               variant="outlined"
//               shape="rounded"
//             />
//           </Stack>
//         </div>
//       </div>
//       <AddMedicineModal
//         isOpen={isOpen}
//         onClose={() => setIsOpen(false)}
//         onSave={handleAddProduct}
//       />
//     </div>
//   );
// };

// export default Products;

import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import AddMedicineModal from "../../Components/AddMedicineModal";
import productService from "../../Services/productService";
import {
  MdSearch,
  MdMedication,
  MdAdd,
  MdWarning,
  MdChevronLeft,
  MdChevronRight,
} from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const ITEMS_PER_PAGE = 10;

const Products = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const getMedicines = async () => {
      try {
        setLoading(true);
        const response = await productService.fetchMedicines();

        // Deduplicate by stock_id — removes any duplicate rows from the join
        const seen = new Set();
        const unique = response.products.filter((item) => {
          if (seen.has(item.stock_id)) return false;
          seen.add(item.stock_id);
          return true;
        });

        setRecords(unique);
      } catch (error) {
        toast.error("Error fetching Medicines");
      } finally {
        setLoading(false);
      }
    };
    getMedicines();
  }, []);

  useEffect(() => {
    const result =
      records?.filter((item) =>
        item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(result);
    setCurrentPage(1);
  }, [searchData, records]);

  useEffect(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    setPaginatedData(filteredData?.slice(start, start + ITEMS_PER_PAGE) || []);
  }, [currentPage, filteredData]);

  const handleAddProduct = (data) => {
    productService.create(data).then(() => {});
  };

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const lowStockCount = records.filter((r) => r.quantity < 4).length;

  const pageNumbers = () => {
    const pages = [];
    const delta = 2;
    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.5s ease both; }
        * { font-family: 'DM Sans', sans-serif; }
        .serif { font-family: 'DM Serif Display', serif; }
      `}</style>

      <div className="min-h-screen bg-[#f4f7fb] py-5 px-3 sm:py-8 sm:px-4 fade-up">
        <div className="max-w-[1400px] mx-auto">

          {/* ── Page Header ── */}
          <div className="mb-5 sm:mb-8 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
            <div>
              <div className="flex items-center gap-2.5 sm:gap-3 mb-1">
                <div
                  className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl flex items-center justify-center shrink-0"
                  style={{ background: "linear-gradient(135deg, #00A95B, #007a40)" }}
                >
                  <MdMedication size={17} className="text-white" />
                </div>
                <h1 className="text-[#0a2540] text-[20px] sm:text-[26px] serif leading-tight">Medicines</h1>
              </div>
              <div className="flex flex-wrap items-center gap-2 sm:gap-3 ml-[42px] sm:ml-12">
                <p className="text-[#8a9bb0] text-[12px] sm:text-sm">
                  {filteredData.length} record{filteredData.length !== 1 ? "s" : ""} found
                </p>
                {lowStockCount > 0 && (
                  <span className="inline-flex items-center gap-1 text-[11px] font-semibold bg-red-50 text-red-500 border border-red-200 px-2.5 py-0.5 rounded-full">
                    <MdWarning size={12} />
                    {lowStockCount} low stock
                  </span>
                )}
              </div>
            </div>

            <button
              onClick={() => setIsOpen(true)}
              className="flex items-center justify-center gap-2 px-4 sm:px-5 py-2.5 rounded-xl text-white text-[13px] sm:text-[14px] font-semibold tracking-[0.3px] transition-all hover:-translate-y-px w-full sm:w-auto sm:self-start"
              style={{
                background: "linear-gradient(135deg, #00A95B 40%, #007a40 100%)",
                boxShadow: "0 4px 16px rgba(0,169,91,0.35)",
              }}
            >
              <MdAdd size={18} />
              Add Medicine
            </button>
          </div>

          {/* ── Search + Table Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] overflow-hidden">

            {/* Search Bar */}
            <div className="px-4 py-3.5 sm:px-6 sm:py-4 border-b border-[#eef1f6]">
              <div className="relative w-full sm:w-[360px]">
                <MdSearch
                  size={18}
                  className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#8a9bb0] pointer-events-none"
                />
                <input
                  type="search"
                  placeholder="Search medicines by name..."
                  value={searchData}
                  onChange={(e) => setSearchData(e.target.value)}
                  className="w-full pl-10 pr-4 py-[10px] bg-[#f8fafc] border-[1.5px] border-[#dde4ed] rounded-xl text-[14px] text-[#0a2540] outline-none transition-all placeholder:text-[#b0bcc9] focus:border-[#00A95B] hover:border-[#00A95B] focus:shadow-[0_0_0_4px_rgba(0,169,91,0.1)] focus:bg-white"
                />
              </div>
            </div>

            {/* ── Table view: md and up ── */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr style={{ background: "#00A95B" }}>
                    {[
                      "Sr. No.",
                      "Medicine Name",
                      "Item Code",
                      "Qty",
                      "Sale Price",
                      "Discounted Price",
                    ].map((h) => (
                      <th
                        key={h}
                        className="px-5 py-3.5 text-[11px] font-semibold uppercase tracking-[0.6px] text-white whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="text-center py-16">
                        <div className="flex flex-col items-center gap-3 text-[#8a9bb0]">
                          <AiOutlineLoading3Quarters
                            size={28}
                            className="animate-spin text-primary"
                          />
                          <span className="text-sm">Loading medicines…</span>
                        </div>
                      </td>
                    </tr>
                  ) : paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => {
                      const isLowStock = item.quantity < 4;
                      const discountedPrice = parseFloat(
                        item.sale_price - item.discount_price
                      ).toFixed(2);

                      return (
                        <tr
                          key={item?.stock_id}
                          className={`text-[13px] border-b border-[#f0f4f8] transition-colors ${
                            index % 2 === 0 ? "bg-white" : "bg-[#fafbfd]"
                          } hover:bg-[#f0fdf7]`}
                        >
                          <td className="px-5 py-3.5 font-bold text-primary">
                            {item?.stock_id}
                          </td>
                          <td className="px-5 py-3.5 font-semibold text-[#0a2540]">
                            {item?.medicine_name}
                          </td>
                          <td className="px-5 py-3.5 text-[#4a6080]">
                            {item?.item_code}
                          </td>
                          <td className="px-5 py-3.5">
                            <span
                              className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[12px] font-semibold border ${
                                isLowStock
                                  ? "bg-red-50 text-red-600 border-red-200"
                                  : "bg-emerald-50 text-emerald-700 border-emerald-200"
                              }`}
                            >
                              {isLowStock && <MdWarning size={12} />}
                              {item?.quantity}
                              {isLowStock && (
                                <span className="text-[10px] font-normal">Low</span>
                              )}
                            </span>
                          </td>
                          <td className="px-5 py-3.5 font-semibold text-[#0a2540]">
                            Rs. {item?.sale_price}
                          </td>
                          <td className="px-5 py-3.5 font-semibold text-primary">
                            Rs. {discountedPrice}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-14">
                        <div className="flex flex-col items-center gap-2 text-[#b0bcc9]">
                          <MdMedication size={32} className="text-[#dde4ed]" />
                          <span className="text-sm">
                            {searchData
                              ? "No medicines match your search."
                              : "No medicines found."}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Card view: below md ── */}
            <div className="md:hidden">
              {loading ? (
                <div className="flex flex-col items-center gap-3 text-[#8a9bb0] py-14">
                  <AiOutlineLoading3Quarters
                    size={26}
                    className="animate-spin text-primary"
                  />
                  <span className="text-sm">Loading medicines…</span>
                </div>
              ) : paginatedData.length > 0 ? (
                <ul className="divide-y divide-[#f0f4f8]">
                  {paginatedData.map((item) => {
                    const isLowStock = item.quantity < 4;
                    const discountedPrice = parseFloat(
                      item.sale_price - item.discount_price
                    ).toFixed(2);

                    return (
                      <li key={item?.stock_id} className="p-4 flex flex-col gap-3">
                        {/* Sr# + Medicine Name + Qty badge */}
                        <div className="flex items-start justify-between gap-3">
                          <div className="min-w-0">
                            <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                              #{item?.stock_id} · Medicine Name
                            </span>
                            <span className="font-semibold text-[#0a2540] text-[14.5px] break-words leading-snug">
                              {item?.medicine_name}
                            </span>
                          </div>
                          <span
                            className={`shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-[11.5px] font-semibold border ${
                              isLowStock
                                ? "bg-red-50 text-red-600 border-red-200"
                                : "bg-emerald-50 text-emerald-700 border-emerald-200"
                            }`}
                          >
                            {isLowStock && <MdWarning size={12} />}
                            Qty {item?.quantity}
                          </span>
                        </div>

                        {/* Item Code + Sale Price + Discounted Price */}
                        <div className="flex items-end justify-between gap-3">
                          <div>
                            <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                              Item Code
                            </span>
                            <span className="inline-flex items-center text-[#4a6080] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg text-[11.5px]">
                              {item?.item_code}
                            </span>
                          </div>
                          <div className="text-right">
                            <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                              Sale Price
                            </span>
                            <span className="font-bold text-[#0a2540] text-[13.5px]">
                              Rs. {item?.sale_price}
                            </span>
                          </div>
                          <div className="text-right">
                            <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                              Discounted
                            </span>
                            <span className="font-bold text-primary text-[13.5px]">
                              Rs. {discountedPrice}
                            </span>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <div className="flex flex-col items-center gap-2 text-[#b0bcc9] py-12 px-4 text-center">
                  <MdMedication size={28} className="text-[#dde4ed]" />
                  <span className="text-sm">
                    {searchData
                      ? "No medicines match your search."
                      : "No medicines found."}
                  </span>
                </div>
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="px-4 py-3.5 sm:px-6 sm:py-4 border-t border-[#eef1f6] flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="hidden sm:block text-[12px] text-[#8a9bb0]">
                  Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
                  {Math.min(currentPage * ITEMS_PER_PAGE, filteredData.length)} of{" "}
                  {filteredData.length} results
                </p>

                {/* Compact prev/next + page label — mobile only */}
                <div className="flex sm:hidden items-center justify-between w-full gap-2">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border border-[#dde4ed] text-[#4a6080] text-[12px] font-medium disabled:opacity-40 disabled:cursor-not-allowed active:enabled:border-[#00A95B] active:enabled:text-primary transition-colors"
                  >
                    <MdChevronLeft size={16} />
                    Prev
                  </button>
                  <span className="text-[12px] font-semibold text-[#0a2540]">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border border-[#dde4ed] text-[#4a6080] text-[12px] font-medium disabled:opacity-40 disabled:cursor-not-allowed active:enabled:border-[#00A95B] active:enabled:text-primary transition-colors"
                  >
                    Next
                    <MdChevronRight size={16} />
                  </button>
                </div>

                {/* Full numbered pagination — sm and up */}
                <div className="hidden sm:flex items-center gap-1.5">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[#4a6080] text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:border-[#00A95B] hover:enabled:text-primary transition-colors"
                  >
                    ‹
                  </button>

                  {pageNumbers()[0] > 1 && (
                    <>
                      <button
                        onClick={() => setCurrentPage(1)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[13px] text-[#4a6080] hover:border-[#00A95B] hover:text-primary transition-colors"
                      >
                        1
                      </button>
                      {pageNumbers()[0] > 2 && (
                        <span className="text-[#b0bcc9] text-sm px-1">…</span>
                      )}
                    </>
                  )}

                  {pageNumbers().map((page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`w-8 h-8 flex items-center justify-center rounded-lg border text-[13px] font-medium transition-colors ${
                        page === currentPage
                          ? "border-[#00A95B] bg-[#00A95B] text-white"
                          : "border-[#dde4ed] text-[#4a6080] hover:border-[#00A95B] hover:text-primary"
                      }`}
                    >
                      {page}
                    </button>
                  ))}

                  {pageNumbers()[pageNumbers().length - 1] < totalPages && (
                    <>
                      {pageNumbers()[pageNumbers().length - 1] < totalPages - 1 && (
                        <span className="text-[#b0bcc9] text-sm px-1">…</span>
                      )}
                      <button
                        onClick={() => setCurrentPage(totalPages)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[13px] text-[#4a6080] hover:border-[#00A95B] hover:text-primary transition-colors"
                      >
                        {totalPages}
                      </button>
                    </>
                  )}

                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[#4a6080] text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:border-[#00A95B] hover:enabled:text-primary transition-colors"
                  >
                    ›
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <AddMedicineModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={handleAddProduct}
      />
    </>
  );
};

export default Products;